// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1NxN4","Label":"BuildControl_Label__2zZ-d","Less":"BuildControl_Less__1B9bG","More":"BuildControl_More__2zqJu"};